
import {
  UserIcon,
  AccountBalanceIcon,
  ContractIcon,
  AssignmentAddIcon,
  ContractEdit,
  DashboardIcon,
  MonitoringIcon
} from '../../assets/svgIcons';
import { ROLES } from '../../constants';

export const menuItems = [
  {
    id: 'home',
    to: '/app/home',
    icon: DashboardIcon,
    text: 'Home',
    roles: [
      ROLES.BACKOFFICE,
      ROLES.PROMOTER,
      ROLES.SALES,
      ROLES.BROKER,
    ],
  },
  {
    id: 'employees',
    to: '/app/funcionarios',
    icon: UserIcon,
    text: 'Funcionários',
    roles: [ROLES.BACKOFFICE, ROLES.PROMOTER, ROLES.BROKER],
  },
  {
    id: 'juridicalPerson',
    to: '/app/pessoa-juridica/consulta-pj',
    icon: AccountBalanceIcon,
    text: 'Pessoa Jurídica',
    roles: [
      ROLES.BACKOFFICE,
      ROLES.PROMOTER,
      ROLES.SALES,
      ROLES.BROKER,
    ],
  },
  {
    id: 'contracts',
    to: '/app/contratos/consulta-contrato',
    icon: ContractIcon,
    text: 'Contratos',
    roles: [
      ROLES.BACKOFFICE,
      ROLES.PROMOTER,
      ROLES.SALES,
      ROLES.BROKER,
    ],
  },
  {
    id: 'contract',
    to: '/app/pessoa-juridica/cadastro-pj',
    icon: AssignmentAddIcon,
    text: 'Cadastro PJ',
    roles: [ROLES.BACKOFFICE, ROLES.BROKER, ROLES.SALES],
  },
  {
    id: 'contractEdit',
    to: '/app/contratos/cadastro-contrato',
    icon: ContractEdit,
    text: 'Cadastro Contrato',
    roles: [ROLES.BACKOFFICE, ROLES.BROKER, ROLES.SALES],
  },
  // {
  //   id: 'boleto',
  //   to: '/app/boleto',
  //   icon: DashboardIcon,
  //   text: 'Boletos',
  //   roles: [ROLES.BACKOFFICE, ROLES.PROMOTER, ROLES.SALES],
  // },
  {
    id: 'sales',
    to: '/app/vendas/cadastro-venda',
    icon: DashboardIcon,
    text: 'Vendas',
    roles: [ROLES.BROKER],
  },
  {
    id: 'health',
    to: '/app/saude',
    icon: MonitoringIcon,
    text: 'Painel de Saúde',
    roles: [
      ROLES.BACKOFFICE,
      ROLES.PROMOTER,
      ROLES.SALES,
      ROLES.BROKER,
    ],
  },
];
